import { Factory } from '..'
import { I18nString } from './i18nstring'
import { applyEntitySchema, sourceJson } from '../../_utils/fcdc-v2'
import { contactPersonSchema } from '../schema/contact-person.schema'

export class ContactPerson {
  name: string
  phoneNumber?: string
  emailAddress?: string
  notes?: I18nString[]

  constructor(json: any) {
    const source = sourceJson(json) as Record<string, unknown>
    const plain: Record<string, unknown> = { ...source }
    if (Array.isArray(source['notes'])) {
      plain['notes'] = source['notes'].map(note => sourceJson(note))
    }

    this.name = plain['name'] as string
    this.phoneNumber = plain['phoneNumber'] as string | undefined
    this.emailAddress = plain['emailAddress'] as string | undefined
    this.notes = Array.isArray(plain['notes'])
      ? (plain['notes'] as unknown[]).map(note => new I18nString(note))
      : undefined
    applyEntitySchema(this, contactPersonSchema, plain, { notes: undefined })
  }

  public static getFactory(): Factory<ContactPerson> {
    return new (class implements Factory<ContactPerson> {
      make(json: any): ContactPerson {
        return new ContactPerson(json)
      }

      getTableName(): string {
        throw new Error(
          'getTableName() should never be called on a Contact person. Contact person are not stored in IndexDB.'
        )
      }
    })()
  }
}
